import { logger } from "~/utils/logger";
/**
 * Global middleware to protect ALL admin routes
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Only apply to admin routes
  if (!to.path.startsWith("/admin")) {
    return;
  }

  // Allow access to signin page
  if (to.path === "/login") {
    return;
  }

  // Server-side: allow page to load, client will handle auth
  if (process.server) {
    return;
  }

  // CLIENT-SIDE ONLY: Check authentication
  const auth = useAuthStore();

  // Try to restore session if not already done
  if (!auth.sessionRestored) {
    await auth.checkKratosSession(false);
  }

  // Check verification
  if (auth.verificationRequired) {
    return navigateTo("/verification", { replace: true });
  }

  // Block if no user
  if (!auth.user) {
    return navigateTo("/login", { replace: true });
  }

  // Block if not admin
  if (auth.user.role !== "ADMIN") {
    return navigateTo("/", { replace: true });
  }
});
